// External Imports:
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

// Local:
import NavBar from "../../Universal Components/NavBar/NavBar";
import { signInWithGithub, signInWithGoogle, signUpWithEmail, signInWithEmail } from "../../Firebase/FirebaseAuth";
import { accountCreation } from "../../Firebase/FireStore";
// CSS:
import "./Login.css"


export default function Login(){
    const navigate = useNavigate();
    const [login_or_signup, set_login_or_signup]  = useState(true);  // True-->Login  False-->register
    const toggle_login_signup = () => {set_login_or_signup(!login_or_signup)};

    const [email_input, set_email_input] = useState("");
    const [password_input, set_password_input] = useState("");

    const [status, set_status] = useState(-1)
    const [message, set_message] = useState("")

    const  singUpInHandler = async (provider) => {
        if (provider === "Google"){
          let response = await signInWithGoogle(navigate);
          set_status(response.code)
          set_message(response.result)
        }
        if(provider === "GitHub"){
          let response = await signInWithGithub(navigate);
          set_status(response.code)
          set_message(response.result)
        }
        await accountCreation();
    }
    const signUpInHandlerEmail = async (email, password) => {
      let response;
      if(login_or_signup){
        response = await signInWithEmail(navigate, email_input, password_input);
      }else{
        response = await signUpWithEmail(navigate, email_input, password_input);
        set_status(response.code);
        set_message(response.result);
        console.log("[AUTH]", response.result);
        return;
      }
      console.log("[AUTH]", response);
      set_status(response.code);
      set_message(response.result);
      if(response.code == 200){
        await accountCreation();
      }
    }

    return(
        <>
            <NavBar/>
            
            <div className="container">

              {
                status === 400 &&
                <div className="error-message">
                  {message}
                  {message ===  "Firebase: Error (auth/invalid-credential)." && "\n\nPerhaps you meant to sign up instead ?"}
                </div>
              }
              {
                status === 300 && 
                <div className="general-message">
                  {message}
                </div>
              }

              <div className="form-box">
                {
                    login_or_signup  ?
                        <h2>Login  </h2> :
                        <h2>Sign Up</h2>
                }
                <button className="oauth-button google-button" onClick={() => singUpInHandler("Google")}>
                  <img className="icon" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt=""/>
                  Google
                </button>
                <button className="oauth-button github-button" onClick={() =>  singUpInHandler("GitHub")}>
                  <img className="icon" src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" alt="" />
                  GitHub
                </button>

                <div className="divider"><span>OR CONTINUE WITH EMAIL</span></div>

                <input 
                  type="email" 
                  placeholder="Email address" 
                  className="login-input"
                  onChange={e => set_email_input(e.target.value)}
                />
                <input 
                  type="password" 
                  placeholder="Password" 
                  className="login-input"
                  onChange={e => set_password_input(e.target.value)}
                />

                {
                  login_or_signup   ?
                  <button className="create-account" onClick={() => signUpInHandlerEmail(email_input, password_input)}>Sign In</button> :
                  <button className="create-account" onClick={() => signUpInHandlerEmail(email_input, password_input)}>Create account</button> 
                }

               

                {!login_or_signup && <div className="swap-options-divider"><span> ALREADY HAVE AN ACCOUNT? </span></div>}
                {login_or_signup && <div className="swap-options-divider"> <span> DON'T HAVE AN ACCOUNT?   </span></div>}
                
                <div className="login-signup-container">
                  <div className="options-box">
                    <button className="sign-up-or-in" onClick={toggle_login_signup}>
                      {
                         login_or_signup   ?
                            <> Sign Up </> :
                            <> Login   </> 
                      }
                    </button>
                  </div>
                </div>

              </div>

             
              <div className="forgot-password-button-wrapper">
                <button className="forgot-password-button">
                    <Link to='/ForgotPassword'>
                      Forgot Password?
                    </Link>
                </button>
              </div>
            </div>
        </>

    );
}